import { getData, setData } from "../utils/storage";
import { normalizeStateData } from "../utils/utility";
import { defaultfilterValues } from "../constants";
import { stateTrailsUnique } from "../constants";
import { fetchFromUrl } from "./utility";

/**
 * Generates a query string based on the filter values.
 *
 * @returns {string} The query string.
 */
const generateQuery = async () => {
  let filterValues;
  try {
    filterValues = JSON.parse(await getData("filterValues"));
    if (filterValues == null || Object.keys(filterValues).length === 0) {
      setData("filterValues", JSON.stringify(defaultfilterValues));
      filterValues = JSON.parse(await getData("filterValues"));
    }

    const query = Object.keys(filterValues)
      .filter((key) => filterValues[key].length > 0)
      .map((key) => {
        const keyQuery = filterValues[key].map((value) => `${key} = '${value}'`).join(" OR ");
        return `(${keyQuery})`;
      })
      .join(" AND ");

    return query;
  } catch (error) {
    // console.log('error ----> ' + error);
  }
};

// add documentation
/**
 * Fetches the trail data from the ArcGIS REST API based on the filter values.
 *
 * @returns {Promise} The promise object representing the trail data.
 */
export const getTrailData = async () => {
  var query = await generateQuery();
  return fetchTrailData(query);
};

/**
 * Fetches trail data by trail ID.
 *
 * @param {string} id - The ID of the trail to fetch data for.
 * @returns {Promise<Object>} A promise that resolves to the trail data object.
 */
export const getTrailDataById = async (id) => {
  var query = `&objectIds=${id}`;
  return await fetchTrailData(query);
};

/**
 * Fetches state trail data by a given ID.
 *
 * @param {number|string} id - The ID of the state trail to fetch.
 * @returns {Promise<Object>} A promise that resolves to the state trail data.
 */
export const getStateTrailById = async (id) => {
  return fetchStateTrails(`OBJECTID+IN+%28${id}`);
};

/**
 * Fetches trail data based on the provided query.
 *
 * @param {string|object} query - The query to be used for fetching trail data. It can be a string or an object.
 * @returns {Promise<any>} A promise that resolves to the fetched trail data.
 */

const fetchTrailData = async (query) => {
  if (typeof query === "object") {
    query = JSON.stringify(query);
  }

  let url = `https://geo.vbgov.com/mapservices/rest/services/Parks_and_Recreation/Parks_and_Recreation/MapServer/0/query?where=${query}&outFields=*&returnGeometry=true&outSR=4326&f=pjson`;
  return fetchFromUrl(url);
};

/**
 * Fetches unique state trails.
 *
 * @async
 * @function fetchStateTrailsUnique
 * @returns {Promise<Object>} A promise that resolves to the fetched trail data.
 */
export const fetchStateTrailsUnique = async () => {
  const items = stateTrailsUnique.map((item) => `'${item}'`).join(",");
  const trailList = encodeURIComponent(items);
  return fetchStateTrails(`TRAIL_NAME+IN+%28${trailList}`);
};

/**
 * Fetches state trails data based on the provided query.
 *
 * @param {string} query - The query string to filter the state trails data.
 * @returns {Promise<Object>} - A promise that resolves to the fetched state trails data in JSON format.
 */
export const fetchStateTrails = async (query) => {
  let url = `https://services1.arcgis.com/PxUNqSbaWFvFgHnJ/ArcGIS/rest/services/StateParkTrails/FeatureServer/3/query?where=DISTRICT+IN+%28%271%27%29+AND+${query}%29&outFields=*&outSR=4326&f=pjson`;
  let json = await fetchFromUrl(url);
  normalizeStateData(json.features);
  return json;
};
